import React, { useState, useEffect, useMemo } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import IndentModal from "../components/storeReqmodal";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";

const AddSfReceipts = () => {
  useAuthRedirect();
  const [showModal, setShowModal] = useState(false);
  const [showVehicleModal, setShowVehicleModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [currentVehicleIndex, setCurrentVehicleIndex] = useState(null);
  const branch = localStorage.getItem("branch");
  const userId = localStorage.getItem("username");
  const [formData, setFormData] = useState({indentNo: "", qty: "" });

  const [indent, setIndent] = useState([]); // single source of truth for table rows
    const [selectedIndent, setSelectedIndent] = useState(""); // indent header number chosen from modal
  
  const [stnNo, setStnNo] = useState('');
  const [dept, setDept] = useState([]);
  const navigate = useNavigate();

   //✅ Permission checks (safe even if perms not yet loaded; will be false)
              const canEntry = hasPermission("Stores Receipt", "entry");
              /////////////////////////////////////////////////////////////
  
// ---- handlers
  const handleSelectIndent = (item) => {
    // item from modal is expected to include indentHeader_number
    setSelectedIndent(item?.indentHeader_number ?? "");
  };

  useEffect(() => {
    const fetchIndentDetails = async () => {
      if (!branch || !selectedIndent) {
        setIndent([]);
        return;
      }
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/purchaseReq_indentDetails?branch=${branch}&indentNo=${selectedIndent}`
        );
        const rows = response?.data?.indentDetails || [];
        // normalize rows with fields we will edit in UI
        const normalized = rows.map((r) => ({
          ...r,
          qty: r?.qty ?? "", // editable
          ref: r?.ref ?? "",
          vcode: r?.vcode ?? "",
          vnumber: r?.vnumber ?? "",
          _tempDeleted: false,
        }));
        setIndent(normalized);
      } catch (error) {
        console.error("Error fetching indent details:", error);
        setIndent([]);
      }
    };

    fetchIndentDetails();
  }, [branch, selectedIndent]);


  const fetchStnNo = async () => {
    try {
      Swal.fire({
                  title: "Fetching Receipt No",
                  html: `
                    <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                      <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                    </div>
                    <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Receipt No...</p>
                  `,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  didOpen: () => {
                    const style = document.createElement("style");
                    style.innerHTML = `
                      @keyframes progressBar {
                        0% { width: 0% }
                        50% { width: 100% }
                        100% { width: 0% }
                      }
                    `;
                    document.head.appendChild(style);
                  },
                });
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/sfReceipt_no?branch=${branch}`); 
        if (response.data.sfNo) {
            const newSfNo = parseInt(response.data.sfNo, 10) || 0;
            setStnNo(newSfNo.toString());
            setFormData(prevState => ({ ...prevState, newPurNo: newSfNo.toString() })); 
        }
        Swal.close();
    } catch (error) {
        Swal.close();
                  console.error("Error fetching Receipt No. Please try again:", error);
                  Swal.fire({
                    icon: "error",
                    title: "Oops!",
                    text: "Error fetching Receipt No. Please try again",
                  });
    }
};

useEffect(() => {
    if (branch) {
      {canEntry && (
        fetchStnNo()
      )}
    }
}, [branch]);


  // change a field in a row by index (qty, ref, etc.)
  const handleRowChange = (index, field, value) => {
    setIndent((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  
  


 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // temp delete (remove row from current draft only)
  const handleDeleteRow = (index) => {
    setIndent((prev) => prev.filter((_, i) => i !== index));
  };



  // Function to submit the form data
 // Row change handler
// const handleRowChange = (index, field, value) => {
//   const updatedData = [...indent];
//   // Always store as string temporarily from input
//   updatedData[index][field] = value;
//   setIndent(updatedData);
// };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (indent.length === 0) {
    Swal.fire("Error", "Please add at least one item", "error");
    return;
  }

  // Validate quantity for all items
  for (const item of indent) {
    const qtyStr = item.qty?.toString() || "";
    const qty = Number(qtyStr);

    if (qtyStr.trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Empty Quantity",
        text: `Please enter Quantity for item "${item.itemmaster_name}"`,
      });
      return;
    }

    if (isNaN(qty) || qty <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Quantity",
        text: `Quantity for item "${item.itemmaster_name}" must be a positive number.`,
      });
      return;
    }
  }

  const payload = {
    branch: branch,
    user: userId,
    sfNo: formData.newPurNo,
    indentNo: selectedIndent,
    remarks: formData.remarks,
    items: indent.map((item) => ({
      itemCode: item.itemmaster_code,
      itemName: item.itemmaster_name,
      itemUom: item.itemmaster_uom,
      price: item.itemmaster_price,
      qty: Number(item.qty), // convert to number before sending
    })),
  };

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.post(
      "https://rfs2.infraconsoft.net.in/api/sfReceipt_insert",
      payload
    );

    Swal.fire("Success", "Store Receipt added successfully", "success");
    setSelectedItems([]);
    navigate("/inventory/sfReceiptsView");
  } catch (error) {
    console.error("Error submitting form:", error);
    Swal.fire("Error", "Submission failed. Please try again.", "error");
  }
};


  if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
          <h2 className="add-txt">Shop Floor Receipts - Add</h2>
          <Link to='/inventory/sfReceiptsView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
          </div>
          <Time />
        </section>

       

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>

          <div className="form-row">
              <div className="form-group">
                <label>Receipt No :</label>
                <input type="text" name="newPurNo" value={formData.newPurNo} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="date" name="endhrs" value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" name="remarks" value={formData.remarks} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Indent Reference :</label>
                <input type="text" name="indentNo" value={selectedIndent} onChange={handleChange} readOnly placeholder="Choose from 'Add Item'"/>
              </div>
            </div>



          <div className="flex_buttons">
          <button type="button" className="button button-add" onClick={() => setShowModal(true)}>Add Item</button>
        </div>
            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Part No</th>
                    <th>UOM</th>
                    <th>Price</th>
                    <th>Received Qty</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {indent.length > 0 ? (
                    indent.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.itemmaster_code}</td>
                        <td>{item.itemmaster_name}</td>
                        <td>{item.itemmaster_drawingNumber}</td>
                        <td>{item.itemmaster_uom}</td>
                        <td>{item.itemmaster_price}</td>
                        <td><input type="number" value={item.qty} onChange={(e) => handleRowChange(index, "qty", e.target.value)} /></td>
                       
                        <td className="del"><i className="fa-solid fa-trash-can" onClick={() => handleDeleteRow(index)}></i></td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">No items added</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>

          </form>
        </div>
      </div>
      <IndentModal showModal={showModal}
        closeModal={() => setShowModal(false)}
        branch={branch}
        onSelectItem={handleSelectIndent} />

    </div>
  );
};

export default AddSfReceipts;